module.exports = __webpack_public_path__ + "img/laugh-beam.dc570a99.svg";